import { useCallback, useMemo, useState } from "react";
import { CustomerEditDrawer } from "../customer-drawer/CustomerEditDrawer";
import { CustomerProfileLauncherContext } from "./CustomerProfileLauncherContext";

export function CustomerProfileOverlayProvider({ children }) {
  const [customer, setCustomer] = useState(null);

  const openCustomerProfile = useCallback((nextCustomer) => {
    if (nextCustomer) setCustomer(nextCustomer);
  }, []);

  const closeCustomerProfile = useCallback(() => setCustomer(null), []);
  const value = useMemo(() => ({ openCustomerProfile, closeCustomerProfile }), [openCustomerProfile, closeCustomerProfile]);

  return (
    <CustomerProfileLauncherContext.Provider value={value}>
      {children}
      <CustomerEditDrawer
        customer={customer}
        open={!!customer}
        defaultTab="customer"
        placement="right"
        onClose={closeCustomerProfile}
        onSaved={updated => setCustomer(updated)}
        onFieldChanged={patch => setCustomer(current => current ? { ...current, ...patch } : current)}
      />
    </CustomerProfileLauncherContext.Provider>
  );
}
